/**
 * axios setup to use mock service
 */

import axios from "axios";



const axiosServices = axios.create({
  baseURL: import.meta.env.VITE_API_BACKEND_URL,
  withCredentials : true,
  withXSRFToken: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    
  }
});


axiosServices.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');

    if(token) {
        config.headers['Authorization'] ='Bearer '+token;
      }
      return config;
    },
    error => {
      Promise.reject(error);
    }
  );

let logoutHandler: (() => void) | null = null;

axiosServices.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && logoutHandler) {
      logoutHandler(); // call store.logout()
    }
    return Promise.reject(err);
  }
);


export function setLogoutHandler(handler: () => void) {
  logoutHandler = handler;
}



export default axiosServices;
